import React, { Component } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import TweenLite, { Power2 } from "gsap/umd/TweenMax";

import { ApiConfig, API_URL } from "./../../settings";
import * as actions from "./../../actions/index";
import { selectStoryTags, selectTagsFilter } from "./../../selectors.js";
import { animateScroll } from "react-scroll";

// Components
import "./style.css";
import MediumSpacer from "./../../components/MediumSpacer";
import LoadingBox from "./../../components/LoadingBox";
import HistoryPreviewBox from "./../../components/HistoryPreviewBox";
import FilterTag from "./../../components/FilterTag";

import StoryIcon from "./../../images/story.svg";
import { updateCanonicalLink } from "../../helpers/helpers.js";

import axios from "axios";

// Småhistorier
class ShortStories extends Component {
    constructor() {
        super();

        this.state = {
            stories: null,
            openFilters: false,
            error: false,
        };

        this.getStories = this.getStories.bind(this);
        this.toggleFilters = this.toggleFilters.bind(this);
    }

    componentDidMount() {
        animateScroll.scrollToTop({ duration: 300 });
        this.getStories();
        this.updatePageMeta()
        updateCanonicalLink();
    }

    componentDidUpdate(prevProps) {
        const { stories } = this.state;
        const { storyTags } = this.props;

        const prevStoryTags = prevProps.storyTags;

        if (storyTags !== prevStoryTags && storyTags && stories) {
            // Gets called when story tags is not yet in Redux store, in other words on page refresh
            this.printStoryTags();
        }
    }
    updatePageMeta() {
        document.title = "Småhistorier";
        let titleOgTag = document.querySelector("meta[property='og:title']");
        titleOgTag.setAttribute('content', "Småhistorier");
        
    }
    getStories() {
        axios
            .get(`${API_URL}/api/stories`, ApiConfig)
            .then((response) => {
                this.setState({
                    stories: response.data,
                    error: false
                })
            })
            .catch((error) => {
                console.error(error);
                this.setState({ error: true });
            })
    }

    printStoryTags() {
        const { stories } = this.state;
        const { storyTags, tagsFilter } = this.props;
        if (!stories || !storyTags) return null;

        // Get all stories which has tags
        const storiesWithTags = stories.filter((item) =>
            item.fields.hasOwnProperty("connectedTags")
        );

        // Get only the tags object
        const storiesTagsIds = storiesWithTags.map((item) =>
            item.fields.connectedTags.map((x) => x.sys.id)
        );

        // Go from 2D to 1D array
        const storiesTagsIdsOneDimention = [].concat.apply([], storiesTagsIds);

        const newStoryTagsArray = storyTags.map((data) => {
            const amount = storiesTagsIdsOneDimention.filter(
                (y) => y === data.sys.id
            ).length;
            return {
                title: data.fields.title,
                id: data.sys.id,
                amount: amount,
            };
        });

        // Filter out values of 0 and return the rest
        return newStoryTagsArray
            .filter((item) => item.amount !== 0)
            .map((data) => {
                return (
                    <FilterTag
                        key={data.id}
                        checked={tagsFilter.includes(data.id)}
                        onClick={() => this.filterbyTags(data.id)}
                    >
                        {data.title} ({data.amount})
                    </FilterTag>
                );
            });
    }

    filterbyTags(id) {
        let { tagsFilter } = this.props;

        const filterExists = tagsFilter.includes(id);

        // Set it to an empty clean array
        if (tagsFilter.size === 0) tagsFilter = [];
        let newFilter = tagsFilter;

        // Add or delete filter from state
        if (filterExists) newFilter = tagsFilter.filter((item) => item !== id);
        else newFilter.push(id);

        this.props.setTagsFilter(newFilter); // Update Redux
    }

    printStories(stories) {
        const { tagsFilter } = this.props;
        // Loops over all stories and checks for posible filteroptions
        return stories.map((data) => {
            let show = false;

            if (tagsFilter.length === 0 || tagsFilter.size === 0) {
                show = true;
            } else if (data.fields.hasOwnProperty("connectedTags")) {
                // If story has tags
                // Checks if the story tags matches filter tags
                const matchesFilter = data.fields.connectedTags.some((item) =>
                    tagsFilter.includes(item.sys.id)
                );
                if (matchesFilter) show = true;
            }

            // Return when valid to show
            if (show) {
                // Removes everything afer "?" (questionmark) if there is any.
                // Does this because a user might upload a string to Contentful like this: ....image.png?w=800
                // Then we would like to remove the size of 800 and instead use our settings
                const img = data.fields.featuredImage;
                const imageUrl = data.fields.hasOwnProperty("featuredImage")
                    ? `${img.substring(
                        0,
                        img.indexOf("?") !== -1
                            ? img.indexOf("?")
                            : img.length
                    )}?w=400`
                    : "https://placehold.co/600x400";

                return (
                    <HistoryPreviewBox
                        key={data.sys.id}
                        title={data.fields.title}
                        link={`/historier/${data.sys.id}`}
                        description={data.fields.body}
                        image={imageUrl}
                    />
                );
            }
            return null;
        });
    }

    toggleFilters() {
        const { openFilters } = this.state;

        if (openFilters) {
            TweenLite.to(this.tags, 0.3, {
                height: "0px",
                ease: Power2.easeInOut,
            });
            TweenLite.to(this.filterPlus, 0.3, {
                rotation: 0,
                ease: Power2.easeInOut,
            });
        } else {
            TweenLite.set(this.tags, { height: "auto" });
            const height = this.tags.clientHeight;
            TweenLite.fromTo(
                this.tags,
                0.3,
                { height: "0px" },
                { height: `${height}px`, ease: Power2.easeInOut }
            );
            TweenLite.to(this.filterPlus, 0.3, {
                rotation: 45,
                ease: Power2.easeInOut,
            });
        }

        this.setState({ openFilters: !openFilters });
    }

    render() {
        const { stories, openFilters, error } = this.state;

        return (
            <div className="short-stories">
                <MediumSpacer />

                <div className="container">
                    <h1 className="page-title">
                        <img
                            className="page-title__icon"
                            src={StoryIcon}
                            alt="Ikon for småhistorier"
                        />
                        Småhistorier
                    </h1>
                    <div className="story-tags-wrapper">
                        <div
                            className="story-tags__accordion-heading button button--white"
                            onClick={this.toggleFilters}
                        >
                            {openFilters ? "Lukk filtre" : "Vis filtre"}
                            <span
                                ref={(comp) => {
                                    this.filterPlus = comp;
                                }}
                            >
                                +
                            </span>
                        </div>
                        <div
                            className="story-tags__inner"
                            ref={(comp) => {
                                this.tags = comp;
                            }}
                        >
                            {this.printStoryTags()}
                        </div>
                    </div>
                    <MediumSpacer />
                    <div className="grid-column-3">
                        {error ? (
                            <p>
                                Det oppstod en feil. Prøv å laste siden på nytt.
                            </p>
                        ) : stories ? (
                            this.printStories(stories)
                        ) : (
                            <LoadingBox text="Laster småhistorier" />
                        )}
                    </div>
                </div>

                <MediumSpacer />
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    storyTags: selectStoryTags(),
    tagsFilter: selectTagsFilter(),
});

const mapDispatchToProps = (dispatch) => {
    return {
        setTagsFilter: (filters) => dispatch(actions.setTagsFilter(filters)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShortStories);



// WEBPACK FOOTER //
// ./src/containers/ShortStories/index.js